import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MenuAddProductModal } from "../components/menuAddProductModal";
import { ProductMenuLayout } from "../layouts/ProductMenuLayout";
import { BusinessInstance } from "../utils/businessClass";
import { VenueInstance } from "../utils/venueClass";
import { Dashboard } from "./DashboardPage";

export const MenuPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const businesses = useSelector((state: any) => state.business);
  const [addScreenOpen, setAddScreenOpen] = useState(false);

  useEffect(() => {
    if (businesses.businessType !== "venue") {
      navigate("/products");
      console.log("redirecting to products");
    }
  }, [navigate, businesses.businessType]);

  const handleSelectBusiness = async (business: any) => {
    console.log(business);
    await BusinessInstance.setBusiness(business);
  };

  const handleOpenAddProduct = () => {
    // Your add product handler
    setAddScreenOpen(!addScreenOpen);
  };

  const handleRemoveFromMenu = (productId: string) => {
    // Your delete handler
    console.log(`deleting ${productId} for venue: ${businesses.activeBusiness.id}`);
    VenueInstance.removeMenuItem(businesses.activeBusiness.id, productId);
  };

  const handleFetchProducts = async () => {
    // Your fetch products handler
    await VenueInstance.getMenu(businesses.activeBusiness.id);
  };

  return (
    <Dashboard>
      {!addScreenOpen ? (
        <ProductMenuLayout
          handleAddProduct={handleOpenAddProduct}
          actions={{
            delete: handleRemoveFromMenu,
            get: handleFetchProducts,
          }}
        ></ProductMenuLayout>
      ) : (
        <MenuAddProductModal onClose={handleOpenAddProduct} />
      )}
    </Dashboard>
  );
};
